import React, {useEffect, useState} from "react";
import {Alert, Backdrop, Button, CircularProgress, Container, Pagination, Paper, styled} from "@mui/material";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import {Link, useLocation} from "react-router-dom";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import ShowSnackbar from "../utils/ShowSnackbar";
import {ApiUrl, PortalUrl} from "../utils/portal-urls";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import ServDescriptionLogsTable from "./ServDescriptionLogsTable";
import RefreshIcon from "@mui/icons-material/Refresh";
import {useDispatch, useSelector} from "react-redux";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import {getAllBatches} from "../features/allBatchesSlice";
import clsx from "clsx";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    boxShadow: '0 7px 20px #cccccc',
    minHeight: 450,
    borderRadius: '15px',
}))
const StyledBatchDiv = styled('div') ({
    marginBottom: '20px',
    '&:last-child': {
        marginBottom: 0,
    }
})
const StyledDiv = styled('div')({
    display: "flex",
    float: "right",
})
const StyledBatchPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
}))

export default function ServDescriptionHome(props) {
    const location = useLocation();
    const path = location.pathname;

    const getParameters = getQueryParams();
    const dynamicHeightPaper = clsx(StyledPaper, {minHeight: 120});

    const [servDescriptionPageResult, setServDescriptionPageResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});
    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);
    const [refresh, setRefresh] = useState(new Date().getTime());

    const dispatch = useDispatch();
    const {servDescriptionId, servDescriptionStatus} = useSelector(state => state.servDescriptionBatch)
    const {servDescriptionBatches, batchRefresh} = useSelector(state => state.allBatches);

    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchServDescriptionLogsPage("servDescription", query, page);
        }

        // fetch batch id when the site loaded
        // getActiveBatchProgress("ImportValueSet", setLoading, setSnackbarMsg)
        //     .then( res => {
        //         res && dispatch(addServDescriptionBatch(res));
        //     })
        dispatch(getAllBatches());

    }, [query, page, refresh, batchRefresh])

    const fetchServDescriptionLogsPage = (source, query, page) => {
        setLoading(true);
        const url = ApiUrl.ExternalSource.getExternalSourceLogs.getPath(source, query, page)
        console.info("Getting ServDescription logs from: " + url);
        fetch(url)
            .then(handleHttpResponse)
            .catch(err => {
                setLoading(false);
                if (err) {
                    console.error(err);
                    setSnackbarMsg({open: true, msg: 'Failed to Get ServDescription Logs', msgLv: 'error'});
                }
            })
            .then(res => {
                setLoading(false)
                if (res) {
                    setServDescriptionPageResult(res);
                    setCurrentViewingQuery(query);
                }
            })
    }

    const onRefresh = () => {
        setRefresh(new Date().getTime());
    }

    return (
        <StyledContainer maxWidth='xl'>
            <ExternalSourceBreadcrumbs path={path}/>
            <h3 className='title'>
                ServDescription
                <StyledDiv>
                    <Button variant="outlined" component={Link}
                            to={PortalUrl.ExternalSource.ServDescription.pattern_new_task} endIcon={<AddIcon/>}>New
                        Import Task
                    </Button>
                    <Button variant="outlined" onClick={() => onRefresh()} endIcon={<RefreshIcon/>}>Refresh</Button>
                </StyledDiv>
            </h3>

            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12}>
                    <h4>ServDescription Logs</h4>
                    <StyledPaper>
                        {servDescriptionPageResult?.content && servDescriptionPageResult.content.length > 0 &&
                            <div>
                                <ServDescriptionLogsTable servDescriptionLogs={servDescriptionPageResult.content}/>
                                <br/>
                                {servDescriptionPageResult.totalPages >= 1 &&
                                    <Pagination page={page + 1} count={servDescriptionPageResult.totalPages}
                                                variant="outlined" color="primary"
                                                onChange={(e, newPage) => setPage(newPage - 1)}/>}
                            </div>}
                    </StyledPaper>

                </Grid>
                <Grid item xs={12} md={12} lg={12} sx={{mt: '25px'}}>
                    <h4>Current ServDescription Progress Information</h4>
                    {/*<StyledPaper sx={{minHeight: '200px'}}>*/}
                    {/*    {servDescriptionStatus && <Alert severity={batchCurrentStatus[servDescriptionStatus].getStatus} icon={false}>{batchCurrentStatus[servDescriptionStatus].getMsg("ServDescription Import Task")}</Alert> }*/}
                    {/*    <br/>*/}
                    {/*    { servDescriptionId && servDescriptionStatus !== 'Completed' && servDescriptionStatus !== 'Cancelled' && servDescriptionStatus !== 'Failed' &&*/}
                    {/*        <ServDescriptionBatchProcessBar /> }*/}
                    {/*</StyledPaper>*/}

                    {servDescriptionBatches.length > 0 ?
                        servDescriptionBatches.map( b => (
                            <StyledBatchDiv key={b.id}>
                                <StyledBatchPaper className={dynamicHeightPaper}>
                                    {b.status &&
                                        <Alert severity={batchCurrentStatus[b.status].getStatus}
                                               icon={false}>{batchCurrentStatus[b.status].getMsg("ServDescription Import Task")}</Alert>}
                                    <br/>
                                    {b.id && b.status !== 'Completed' && b.status !== 'Cancelled' && b.status !== 'Failed' &&
                                        // <ServDescriptionBatchProcessBar batch={b}/>}
                                    <ExternalSourceBatchProgressBar batch={b}/>}
                                </StyledBatchPaper>
                            </StyledBatchDiv>
                        )) :
                        <StyledPaper sx={{minHeight: '200px'}}>
                            {<Alert severity='info' icon={false}>No Active Process</Alert> }
                        </StyledPaper>
                    }
                </Grid>
            </Grid>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg}/>
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={loading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}